(function () {
    'use strict';

    /*
     * An AngularJS Localization Service
     */
    angular.module('harriApp')
        .factory('localize', ['$q', '$locale', 'hTransitions', function ($q, $locale, hTransitions) {

            var localize = {
                inited: false,
                language: "",
                locales: {},
                disabled: false,
                localeDisabled: false,
                init: function (forceInit) {
                    if (forceInit || !localize.inited) {
                        moment.updateLocale('ar', {
                            preparse: function (string) {
                                return string;
                            },
                            postformat: function (string) {
                                return string;
                            }
                        });
                        localize.inited = true;
                    }
                },
                isRTL: function () {
                    var rtl_languages = ['ar'];
                    return rtl_languages.indexOf(localize.getLang()) > -1;
                },
                isRouteDisabled: function (stateName) {
                    return ['appLayout.schedule.'].reduce(function (prevValue, route) {
                        return  prevValue || stateName.indexOf(route) > -1;
                    }, false);
                },
                getLocaleCode: function () {
                    var lang = localize.getLang();
                    if (lang === 'es') {
                        return 'en'
                    }
                    return lang;
                },
                getLang: function() {
                    if (localize.disabled) {
                        return 'en';
                    }
                    var hostLang = window.location.hostname.split(".")[0];
                    var supportedLanguages = publicConfiguration.i18n.supportedLanguages;

                    localize.language = (supportedLanguages.indexOf(hostLang) >= 0) ? hostLang : 'en';
                    localize.language = publicConfiguration.i18n.languageParser(localize.language, publicConfiguration.i18n);

                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        key: 'lang',
                        value: localize.language,
                        codec: false,
                        expiryDays: 30
                    });

                    return localize.language;
                },
                disableLocale: function () {
                    localize.localeDisabled = true;
                    localize.loadLocaleScript('en');
                    moment.locale('en');

                    if (localize.isRTL()) {
                        $('body').hasClass('rtl') && $('body').removeClass('rtl');
                    }
                },
                enableLocale: function () {
                    localize.loadLocaleScript(localize.getLang());
                    moment.locale(localize.getLocaleCode());

                    if (localize.isRTL()) {
                        hTransitions.onSuccess({}, function (trans) {
                            !$('body').hasClass('rtl') && $('body').addClass('rtl');
                            localize.localeDisabled = false;
                        });
                    } else {
                        localize.localeDisabled = false;
                    }
                },
                loadLocaleScript: function (locale) {
                    var defer = $q.defer();

                    if (locale === 'es') {
                        locale = 'en';
                    }

                    var scriptBaseURL = CDNUri + 'angular-i18n/';

                    if (!CDNUri) {
                        scriptBaseURL = 'node_modules/angular-i18n/';
                    }

                    var scriptURL = scriptBaseURL + 'angular-locale_' + locale + '.js';


                    if (localize.locales[locale]) {
                        $locale = $.extend($locale, localize.locales[locale]);
                        defer.resolve($locale);
                    } else {
                        $.getScript(scriptURL, function (data, textStatus) {
                            localize.locales[locale] = {};

                            var ngLocale = angular.injector(['ngLocale']);
                            var newLocale = ngLocale.get('$locale');
                            newLocale['localeID'] = locale;

                            $locale = $.extend($locale, newLocale);
                            localize.locales[locale] = $.extend(localize.locales[locale], $locale);

                            if (textStatus === 'success') {
                                defer.resolve($locale);
                            } else {
                                defer.reject({});
                            }
                        }).fail(function (jqxhr, settings, exception) {
                            console.error(exception);
                            defer.reject({});
                        });
                    }

                    return defer.promise;
                }
            };

            return localize;
        }]);
})();
